// src/components/CaseReward.js (ФИНАЛЬНАЯ ИСПРАВЛЕННАЯ ВЕРСИЯ)
import React, { useState, useEffect } from 'react';

// Константы
const PRIZE_WIDTH = 100; // Ширина карточки
const PRIZE_MARGIN = 5;  // Отступ с каждой стороны
const TOTAL_PRIZE_WIDTH = PRIZE_WIDTH + (PRIZE_MARGIN * 2); // Полная ширина ячейки (110px)

export default function CaseReward({ reward, onAnimationEnd, ALL_PRIZES }) {
  const [style, setStyle] = useState({});
  const [isRevealed, setIsRevealed] = useState(false);

  const ROULETTE_ITEMS = [...ALL_PRIZES, ...ALL_PRIZES, ...ALL_PRIZES, ...ALL_PRIZES, ...ALL_PRIZES];

  useEffect(() => {
    // 1. Находим индекс реального приза
    let rewardIndex = ALL_PRIZES.findIndex(p => {
      if (p.type === reward.type) {
        if (p.type === reward.type) {
          if (p.type === 'jackpot') return true;
          // --- ИЗМЕНЕНИЕ: Проверяем и points, и roleDays, и xp ---
          return p.value === (reward.points || reward.roleDays || reward.xp);
        }
      }
      return false;
    });
    if (rewardIndex === -1) rewardIndex = 0;

    // 2. Выбираем целевой элемент в середине "длинной ленты"
    const targetIndex = rewardIndex + (ALL_PRIZES.length * 2);

    // 3. --- КЛЮЧЕВОЕ ИСПРАВЛЕНИЕ: ПРАВИЛЬНЫЙ РАСЧЕТ СМЕЩЕНИЯ ---
    // Нам нужно сдвинуть ленту так, чтобы ЦЕНТР целевого приза оказался под указателем.
    // Указатель находится в центре ОКНА. Лента начинается от ЦЕНТРА ОКНА (`left: 50%`).
    // Значит, нам нужно сдвинуть ленту влево на расстояние от ее начала до ЦЕНТРА целевого приза.
    const offsetToCenterOfPrize = (targetIndex * TOTAL_PRIZE_WIDTH) - (PRIZE_WIDTH / 3);

    // Добавляем случайное "дрожание" для реалистичности
    const finalOffset = offsetToCenterOfPrize + PRIZE_WIDTH - PRIZE_MARGIN * 2;

    // 4. Запускаем анимацию
    const startTimer = setTimeout(() => {
      setStyle({
        transform: `translateX(-${finalOffset}px)`,
        transition: 'transform 8s cubic-bezier(0.2, 0.8, 0.25, 1)',
      });
    }, 100);

    // 5. Управление состоянием
    const revealTimer = setTimeout(() => setIsRevealed(true), 8100);
    const endTimer = setTimeout(onAnimationEnd, 11100);

    return () => {
      clearTimeout(startTimer);
      clearTimeout(revealTimer);
      clearTimeout(endTimer);
    };
  }, [reward, onAnimationEnd]);

  return (
    <div className="case-reward-container">
      <div className="roulette-window">
        <div className="roulette-track" style={style}>
          {ROULETTE_ITEMS.map((prize, i) => (
            <div key={i} className={`prize-item type-${prize.type}`}>
              <span>{prize.value}</span>
              <small>
                {prize.type === 'points' ? 'очков' :
                  (prize.type === 'role' ? 'дней роли' :
                    (prize.type === 'xp_booster' ? 'XP' : ''))}
              </small>
            </div>
          ))}
        </div>
        <div className="roulette-pointer"></div>
      </div>
      {isRevealed && <p className="reward-message revealed">{reward.description}</p>}
    </div>
  );
}